"use strict";

import mixitup from 'mixitup';
import mixitupPagination from '../optional/mixitup-pagination.min.js';

mixitup.use(mixitupPagination);

jQuery(document).ready(function ($) {

    if ($('.post-cards--overview').length) {

        let selectFilter = document.querySelector('.select-filter');
        let container = document.querySelector('.post-cards--overview');

        let args = {
            selectors: {
                target: '.mix'
            },
            animation: {
                duration: 500
            },
            pagination: {
                limit: 9,
                hidePageListIfSinglePage: true,
            }
        };
        let mixer = mixitup(container, args);

        selectFilter.addEventListener('change', function () {
            let selector = selectFilter.value;
            mixer.filter(selector);
        });
    }
});